function relivHideUpsellIfDismissed(root) {
  if (sessionStorage.getItem('relivUpsellDismissed') !== '1') return;
  (root || document).querySelectorAll('[data-reliv-cart-upsell]').forEach((el) => el.remove());
}

function relivSwapOffer(button, container) {
  const cartUrl = container.dataset.cartUrl || '/cart';
  const removeVariantId = button.dataset.removeVariantId;
  const addVariantId = button.dataset.addVariantId;
  const label = button.querySelector('[data-reliv-upsell-swap-label]');
  const originalText = label ? label.textContent : '';

  button.setAttribute('disabled', 'disabled');
  if (label) label.textContent = 'Updating…';

  fetch(`${cartUrl}/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: removeVariantId, quantity: 0 }),
  })
    .then((response) => response.json())
    .then(() =>
      fetch(`${cartUrl}/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: addVariantId, quantity: 1 }] }),
      })
    )
    .then((response) => response.json())
    .then(() => relivRefreshCartSections(cartUrl))
    .catch((error) => {
      console.error(error);
      button.removeAttribute('disabled');
      if (label) label.textContent = originalText;
    });
}

function relivRefreshCartSections(cartUrl) {
  const sectionIds = ['cart-drawer', 'cart-icon-bubble'];
  return Promise.all(
    sectionIds.map((id) =>
      fetch(`${cartUrl}?section_id=${id}`)
        .then((response) => response.text())
        .then((html) => ({ id, html }))
    )
  ).then((results) => {
    const parser = new DOMParser();
    results.forEach(({ id, html }) => {
      const doc = parser.parseFromString(html, 'text/html');
      if (id === 'cart-drawer') {
        ['cart-drawer-items', '.cart-drawer__footer'].forEach((selector) => {
          const target = document.querySelector(selector);
          const source = doc.querySelector(selector);
          if (target && source) target.replaceWith(source);
        });
      } else {
        const target = document.getElementById('cart-icon-bubble');
        const source = doc.getElementById('cart-icon-bubble');
        if (target && source) target.replaceWith(source);
      }
    });
  });
}

// Event delegation: the cart drawer gets replaced wholesale by Dawn's own
// AJAX refresh cycle (see CartItems.onCartUpdate in cart.js), which would
// strand any listeners bound directly to elements inside it. Binding once on
// document instead means the upsell prompt keeps working across any number
// of drawer re-renders, however they were triggered.
document.addEventListener('click', (event) => {
  const dismissButton = event.target.closest('[data-reliv-upsell-dismiss]');
  if (dismissButton) {
    sessionStorage.setItem('relivUpsellDismissed', '1');
    dismissButton.closest('[data-reliv-cart-upsell]')?.remove();
    return;
  }

  const swapButton = event.target.closest('[data-reliv-upsell-swap]');
  if (swapButton) {
    const container = swapButton.closest('[data-reliv-cart-upsell]');
    if (container) relivSwapOffer(swapButton, container);
  }
});

// Re-apply the dismissed state whenever the drawer content changes, since
// server-rendered refreshes have no knowledge of the client-side dismissal.
const relivUpsellObserver = new MutationObserver(() => relivHideUpsellIfDismissed());
document.addEventListener('DOMContentLoaded', () => {
  relivHideUpsellIfDismissed();
  relivUpsellObserver.observe(document.body, { childList: true, subtree: true });
});
